import { Component, OnInit, Inject } from "@angular/core";
import {
  MatDialog,
  MAT_DIALOG_DATA,
} from "@angular/material";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "src/_services/app.service";
import { AuthenticationService } from "src/_services/authentication.service";
import { Location } from "@angular/common";

@Component({
  selector: 'app-provider-markets',
  templateUrl: './provider-markets.component.html',
  styleUrls: ['./provider-markets.component.scss']
})
export class ProviderMarketsComponent  implements OnInit {
  providersDisplayedColumns: string[] = [
    "ProviderId",
    "ProviderName",
    "Status",
    "Action",
  ];

  providers = [];
  providersStatus = [];
  operatorStatus: any[]=[]; 
  operatorId: string;
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  data : any;
  showOperatorData: boolean = true;
  constructor(
    private appService: AppService,
    private router: Router,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private location: Location,
  ) {}

  ngOnInit() {
    this.operatorId = this.route.snapshot.params.operatorId;
    this.getProviders()
    this.getOurProviders(this.operatorId);
  }

  getOurProviders(oid) {
    try {
      this.appService.getOperatorProvidersStatus(oid).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorStatus = res.operatorStatus;
          this.data = res.operatorStatus
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  isProviderEnabled(providerId: string): boolean {
    const operator = this.operatorStatus.find((op) => op.providerId === providerId);
    return operator ? operator.isEnabled : false;
  }

  handleClick(element) {
    if (this.userRole.role === "SAPAdmin" || this.userRole.role === "SAPUser" || this.userRole.role === "RiskAdmin") {
      this.providersStatus = this.operatorStatus.find((operator) => operator.providerId === element.ProviderId);
      const dialogRef = this.dialog.open(MarketStatusModalComponent, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          providersStatus: this.providersStatus,
        },
      });
      dialogRef.afterClosed().subscribe(() => {
        this.getOurProviders(this.operatorId);
      }); 
      console.log(this.providersStatus)
    }
  }

  getProviders(){
    try{
      this.appService.getProviders().subscribe((res)=>{
        this.providers=res.providers
      })
    }catch(err){
      console.log(err)
    }
  }

  handleChange(e, providerId) {
    let provider = this.operatorStatus.find((operator) => operator.providerId === providerId.ProviderId);
    if (e.checked) {
      let filters = {
        providerId : providerId.ProviderId,
        isEnabled : e.checked,
        operatorId : this.operatorId,
      }
      this.appService.enableProvider(filters).subscribe((res) => {
          if (res.status === "RS_OK") {

            this.appService.openSuccessBar("ENABLED");
            this.getOurProviders(this.operatorId);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    } else {
      let filters = {
        providerId : providerId.ProviderId,
        isDisabled : !e.checked,
        operatorId : this.operatorId,
      }
      this.appService.disableProvider(filters).subscribe((res) => {
          if (res.status === "RS_OK") {
            this.getOurProviders(this.operatorId);
            this.appService.openSuccessBar("DISABLED");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    }
  }

  goBack = () => {
    this.location.back();
  };
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./market-info-modal.html",
  styleUrls: ["./provider-markets.component.scss"],
})
export class MarketStatusModalComponent {
  labels = ['Match Odds', 'Book Makers', 'Fancy', 'Premium', 'Virtuals'];
  marketChecks = ['matchOdds', 'bookMakers', 'fancy', 'premium', 'virtuals'];
  providerStatusDisplayedColumns: string[] = [
    "MarketId",
    "Status",
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private appService: AppService
  ) {}

  dataSource = Object.entries(this.data).map(([market, status]) => ({
    market,
    status,
  }));

  ngOnInit () {}

  handleChangeStatus(property: string, checked: boolean, element: any) {
    element = element.status;
    let filters = {
      providerId: element.providerId,
      operatorId: element.operatorId,
      [property]: checked,
    };
    if (checked) {
      console.log(filters)
      this.appService
        .enableProvider(filters)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("Market Active");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    } else {
      filters[property] = !checked;
      this.appService
        .disableProvider(filters)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar("Market Blocked");
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    }
  }
}